export default __webpack_public_path__ + "static/media/levelthree_segment.a39d098a.svg";